import { Module } from 'mana-syringe';
import { DOMInteractionPlugin } from './DOMInteractionPlugin';
var containerModule = Module(function (register) {
  register(DOMInteractionPlugin);
});

var Plugin =
/** @class */
function () {
  function Plugin() {}

  Plugin.prototype.init = function (container) {
    container.load(containerModule, true);
  };

  Plugin.prototype.destroy = function (container) {
    container.unload(containerModule);
  };

  return Plugin;
}();

export { Plugin };